import httpResource from "@/components/infrastructures/functions/http/httpResource";

export default class CreditCardService {

    public static async delete(cardId: string) {
        return (await httpResource.post('/v2/payment/card/delete', {id: cardId})).data;
    }
}